import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.services';
import { GlobalMessageService } from '../../shared/services/global-message.service';
import { SimulationService } from '../../shared/services/simulation.service';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RoleChildGuard: CanActivateChildFn = (childRoute, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const globalMessageService = inject(GlobalMessageService);
  const simulationService = inject(SimulationService);

  const required: readonly string[] = childRoute.data?.['roles'] ?? [];
  const userRoles: readonly string[] = auth.getRoles() ?? [];

  // Verificar se o usuário tem pelo menos uma das permissões necessárias.
  const allowed = required.length === 0 || required.some(r => userRoles.includes(r));

  if (!allowed) {
    if (simulationService.isSimulating()) {
      globalMessageService.addMessage({
        type: 'warning',
        message: 'Não é possível iniciar simulação. Encerre a sessão atual ou tente novamente.',
      });
    } else {
      globalMessageService.addMessage({
        type: 'warning',
        message: 'Você não tem permissão para acessar esta página.',
      });
    }
    return router.createUrlTree(['/home']);
  }

  return true;
};
